import React, { Fragment, useEffect, useMemo } from 'react';
import { useStores } from '../../../hooks/use-stores';
import { Observer, observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ThemedSpinner from '../../../components/themed/ThemedSpinner';
import SimpleTable from '../../../components/super/SimpleTable';
import { formatDate } from '../../../utils/helpers';
import DeleteIcon from '@material-ui/icons/Delete';
import AddManager from '../../../components/super/add-manager';

const useStyles = makeStyles(() => ({
    label: {
        fontSize: 12,
        fontWeight: 800,
        paddingRight: 2,
    },

    keyValue: {
        whiteSpace: 'nowrap',
        flexWrap: 'nowrap',
    },

    value: {
        fontSize: 12,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontFamily: 'monospace',
    },
    divider: {
        marginTop: 10,
        marginBottom: 10,
    },
}));

function Builds() {
    const { superStore} = useStores();
    const {
        admins,
        loadingAdmins,
        adminsError: error,
        removingAdmins,
        addingSuperAdmin,
    } = superStore;

    const addManager = (name, email) => {
        superStore.addSuperAdmin({ name, email });
    };

    const removeManager = (email) => {
        superStore.removeAdmin(email);
    };

    const columns = useMemo(() => {
        return [
            {
                Header: 'Created',
                accessor: 'created',
                Cell: (x) => formatDate(x.value),
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                id: 'deleteManager',
                accessor: (x) => (
                    <Observer>
                        {() => {
                            return (
                                <>
                                    {removingAdmins.includes(x.email) ? (
                                        <ThemedSpinner />
                                    ) : (
                                        <IconButton
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => {
                                                removeManager(x.email);
                                            }}
                                        >
                                            <DeleteIcon fontSize="large" />
                                        </IconButton>
                                    )}
                                </>
                            );
                        }}
                    </Observer>
                ),
            },
        ];
    }, []);

    useEffect(() => {
        superStore.loadAdmins();
    }, []);

    if (loadingAdmins) {
        return <ThemedSpinner />;
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            align="center"
            spacing={2}
        >
            <Grid container item xs={12}>
                {' '}
                {error && (
                    <Alert variant={'filled'} color={'error'}>
                        {error}
                    </Alert>
                )}
            </Grid>
            <Grid container justifyContent='center' item xs={12}>
                <Typography variant="h5">Super Admins</Typography>
            </Grid>
            <Grid item xs={12}>
                <AddManager
                    addingManager={addingSuperAdmin}
                    addManager={addManager}
                    hideRoleSelector
                    hideSendLoginInfo
                />
            </Grid>

            <Grid item xs={12}>
                <SimpleTable
                    columns={columns}
                    data={admins.slice(0)}
                    needsFilter={false}
                />
            </Grid>
        </Grid>
    );
}

export default observer(Builds);
